/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionproblemempty2Inputs */

const en_actionproblemempty2 = /** @type {(inputs: Actionproblemempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a text.`)
};

const de_actionproblemempty2 = /** @type {(inputs: Actionproblemempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreib einen Text.`)
};

/**
* | output |
* | --- |
* | "Write a text." |
*
* @param {Actionproblemempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionproblemempty2 = /** @type {((inputs?: Actionproblemempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionproblemempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionproblemempty2(inputs)
	return de_actionproblemempty2(inputs)
});
export { actionproblemempty2 as "actionProblemEmpty" }